var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Toast from 'bootstrap/js/dist/toast';
export class Toast extends Component {
    constructor() {
        super('Toast', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.toast').each((toastElement) => {
                Toast.toastInstance = new BS_Toast(toastElement.get(0));
            });
            this.success();
        });
    }
    static show(message) {
        $('.toast-body').html(message);
        if (Toast.toastInstance)
            Toast.toastInstance.show();
        clearTimeout(Toast.toastTimeout);
        Toast.toastTimeout = window.setTimeout(() => {
            if (Toast.toastInstance)
                Toast.toastInstance.hide();
        }, 5000);
    }
}
Toast.toastInstance = null;
Toast.toastTimeout = null;
